import * as Types from '@crimeos-frontend/crime-os/graphql'

import { gql } from '@apollo/client'
import {
  AttachmentFragmentDoc,
  TaskRequiredFieldsNotFilledFragmentDoc
} from '@crimeos-frontend/crime-os/graphql-docs'
import * as Apollo from '@apollo/client'
export type GetDataControllerServiceRequestPropertiesQueryVariables =
  Types.Exact<{
    params: Types.GetTaskServiceRequestPropertiesParams
  }>

export type GetDataControllerServiceRequestPropertiesQuery = {
  __typename: 'Query'
  getTaskServiceRequestProperties:
    | { __typename: 'AccessDeniedToServiceRequest'; message?: string | null }
    | {
        __typename: 'TaskAccessDenied'
        message?: string | null
        taskId: number
      }
    | { __typename: 'TaskNotFound'; message?: string | null; taskId: number }
    | {
        __typename: 'TaskRequiredFieldsNotFilledResult'
        taskId: number
        notFilledRequiredFields: Array<{
          __typename: 'TaskRequiredFieldsNotFilled'
          templateId: string
          recordId: string
          requiredFields: Array<string>
          optionalFields: Array<string>
          createdAt: string
        }>
      }
    | {
        __typename: 'TaskServiceRequestProperties'
        taskId: number
        requestData:
          | {
              __typename: 'AccessDeniedToServiceRequest'
              message?: string | null
            }
          | { __typename: 'RequestData'; requestData: Array<string> }
        requestAttachments: Array<{
          __typename: 'Attachment'
          attachmentId: number
          name: string
          type: Types.AttachmentType
          url: string
          attachmentCategory?: Types.AttachmentCategory | null
        }>
      }
}

export const GetDataControllerServiceRequestPropertiesDocument = gql`
  query GetDataControllerServiceRequestProperties(
    $params: GetTaskServiceRequestPropertiesParams!
  ) {
    getTaskServiceRequestProperties(params: $params) {
      ... on TaskServiceRequestProperties {
        taskId
        requestData {
          ... on RequestData {
            requestData
          }
          ... on AccessDeniedToServiceRequest {
            message
          }
        }
        requestAttachments {
          ...Attachment
        }
      }
      ... on TaskRequiredFieldsNotFilledResult {
        taskId
        notFilledRequiredFields {
          ...TaskRequiredFieldsNotFilled
        }
      }
      ... on AccessDeniedToServiceRequest {
        message
      }
      ... on TaskNotFound {
        message
        taskId
      }
      ... on TaskAccessDenied {
        message
        taskId
      }
    }
  }
  ${AttachmentFragmentDoc}
  ${TaskRequiredFieldsNotFilledFragmentDoc}
`
export type GetDataControllerServiceRequestPropertiesQueryResult =
  Apollo.QueryResult<
    GetDataControllerServiceRequestPropertiesQuery,
    GetDataControllerServiceRequestPropertiesQueryVariables
  >
